import React, { useState } from 'react';
import { DateRangePicker, Calendar } from 'react-date-range';
import { FormControlLabel, Fab, Switch, Grid, Typography } from '@material-ui/core';
import { dateToYmdStr, useRecentGetter, useToggle } from '@lib/common';
import { useCallback } from 'react';
import FilterIcon from '@material-ui/icons/FilterList';
import { $eq, $bw } from '../operators';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

export const DateFilters = ({ column: { setFilter, filterValue }, closeFilter }) => {
  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: null,
      key: 'selection',
    },
  });

  const [isRangeMode, toggleMode] = useToggle(false);
  const [date, setDate] = useState(null);

  const getFilterValue = useRecentGetter(filterValue);
  const isRange = useRecentGetter(isRangeMode);
  const getRange = useRecentGetter(state);
  const getDate = useRecentGetter(date);

  const applyFilter = useCallback(() => {
    const filter = {
      [isRange() ? $bw.key : $eq.key]: isRange()
        ? [dateToYmdStr(getRange().selection.startDate), dateToYmdStr(getRange().selection.endDate)]
        : dateToYmdStr(getDate()),
    };
    setFilter({
      ...getFilterValue(),
      ...filter,
    });
    closeFilter();
  }, [closeFilter]);

  return (
    <>
      <Grid container justify="space-between">
        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            control={<Switch color="primary" checked={isRangeMode} onChange={toggleMode} />}
            label="Single"
            labelPlacement="start"
          />
          &nbsp;&nbsp;
          <Typography variant="body1" display="inline">
            Range
          </Typography>
        </Grid>
        <Grid item>
          <Fab
            color="primary"
            disabled={isRangeMode ? !state.selection.endDate || !state.selection.startDate : !date}
            size="small"
            onClick={applyFilter}>
            <FilterIcon />
          </Fab>
        </Grid>
      </Grid>
      <br />
      {!isRangeMode ? (
        <Calendar onChange={setDate} date={date} />
      ) : (
        <DateRangePicker
          onChange={setState as any}
          direction="vertical"
          scroll={{ enabled: true }}
          ranges={[state.selection]}
        />
      )}
    </>
  );
};
